import axios from "axios"
import { API_URL, getHeader } from "../config"

export const getHighlight = async () => {
    const { data } = await axios.get(API_URL + `/api/highlight/SFSAP`);
    return data;
}
export const getHighlightAll = async () => {
    const { data } = await axios.get(API_URL + `/api/highlight/all/SFSAP`);

    return data;
}

export const getNews = async () => {
    const { data } = await axios.get(API_URL + `/api/news/SFSAP`);

    return data;
}

export const getNewsInner = async () => {
    const { data } = await axios.get(API_URL + `/api/news/All/SFSAP`);

    return data;
}
export const getEvents = async () => {
    const { data } = await axios.get(API_URL + `/api/events/SFSAP`);

    return data;
}

export const getEventsinner = async () => {
    const { data } = await axios.get(API_URL + `/api/events/All/SFSAP`);

    return data;
}

export const getVideo = async () => {
    const { data } = await axios.get(API_URL + `/api/video/All/SFSAP`);
    return data;
}

export const getGallery = async () => {
    const { data } = await axios.get(API_URL + `/api/gallery/SFSAP`);
    return data;
}

export const getGalleryInner = async () => {
    const { data } = await axios.get(API_URL + `/api/gallery/All/SFSAP`);

    return data;
}

export const getSubGallery = async (id) => {
    const { data } = await axios.get(API_URL + `/api/subGallery?id=${id}`);
    return data;
}

export const getNotification = async () => {
    const { data } = await axios.get(API_URL + `/api/notification/SFSAP`, getHeader());
    return data;
}

export const getTopper = async () => {
    const { data } = await axios.get(API_URL + `/api/topper/SFSAP`, getHeader());
    return data;
}

export const getBirthdays = async () => {
    const { data } = await axios.get(API_URL + `/api/birthdays/SFSAP`);
    return data;
}
export const getOnlineRegistration = async () => {
    return axios.get(API_URL + `/api/onlineRegistration/SFSAP`, getHeader());
}
export const getCircular = async () => {
    const { data } = await axios.get(API_URL + `/api/circular/all/SFSAP`, getHeader());

    return data;
}

export const getActivity = async () => {
    const { data } = await axios.get(API_URL + `/api/activity/all/SFSAP`, getHeader());
    return data;
}

export const getPrincipalMessage = async () => {
    const { data } = await axios.get(API_URL + `/api/PrincipalMessage/SFSAP`, getHeader());
    return data;
}


export const postTransferCertificate = async (name, admission) => {
    const { data } = await axios.post(API_URL + `/api/tc/SFSAP`, { name, admission }, getHeader());
    return data;
}

export const postVisitor = async () => {
    const { data } = await axios.post(API_URL + `/api/visitor`, { schoolcode: "SFSAP" }, getHeader());
    return data;
}
export const getVisitor = async () => {
    const { data } = await axios.get(API_URL + `/api/visitor/SFSAP`, getHeader());

    return data;
}
